export default {
  clearAll() {
    window.sessionStorage.clear();
  },

  get(key) {
    try {
      const value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return window.sessionStorage.getItem(key);
    }
  },

  set(key, value) {
    const storedValue =
      typeof value === 'object' ? JSON.stringify(value) : value;
    window.sessionStorage.setItem(key, storedValue);
  },

  remove(key) {
    window.sessionStorage.removeItem(key);
  },
};
